import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Plus } from 'lucide-react';
import { usePolls } from '../hooks';
import { PollCard } from '../components';

export function PollListPage() {
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState<string | undefined>(undefined);
  const { polls, loading, error, hasMore, loadMore } = usePolls({ status: statusFilter });

  const filters = [
    { label: 'All', value: undefined },
    { label: 'Draft', value: 'draft' },
    { label: 'Active', value: 'active' },
    { label: 'Closed', value: 'closed' },
  ];

  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">My Polls</h1>
        <Button onClick={() => navigate('/a/arche_polls/create')}>
          <Plus className="h-4 w-4 mr-2" />
          Create Poll
        </Button>
      </div>

      <div className="flex gap-2 mb-4">
        {filters.map((f) => (
          <Button
            key={f.label}
            variant={statusFilter === f.value ? 'default' : 'outline'}
            size="sm"
            onClick={() => setStatusFilter(f.value)}
          >
            {f.label}
          </Button>
        ))}
      </div>

      {loading && polls.length === 0 ? (
        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-24 w-full" />
          ))}
        </div>
      ) : error ? (
        <p className="text-destructive">{error}</p>
      ) : polls.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">
          <p>No polls yet. Create your first poll to get started.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {polls.map((poll) => (
            <PollCard
              key={poll.pollId}
              pollId={poll.pollId}
              title={poll.title}
              status={poll.status}
              closesAt={poll.closesAt}
              createdAt={poll.createdAt}
            />
          ))}
          {hasMore && (
            <div className="flex justify-center pt-4">
              <Button variant="outline" onClick={loadMore} disabled={loading}>
                Load More
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
